import { Navigate } from "react-router-dom";
import { useSession } from "@/session/SessionProvider";
import { Button } from "@/components/primitives/Button";
import { PublicLayout } from "@/components/layout/PublicLayout";

export default function Landing() {
	const { isAuthed, isLoading } = useSession();
	if (!isLoading && isAuthed) return <Navigate to="/app" replace />;

	return (
		<PublicLayout>
			<main className="flex flex-1 flex-col items-center justify-center gap-8 px-4 py-16">
				<div className="max-w-md text-center">
					<h1 className="text-3xl font-semibold tracking-tight text-fg">Kartenwerk</h1>
					<p className="mt-2 text-sm text-fg-muted">Karten. Ebenen. Teilen.</p>
					<ul className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-fg-muted">
						<li>zeichnen</li>
						<li aria-hidden>·</li>
						<li>teilen</li>
						<li aria-hidden>·</li>
						<li>übernehmen</li>
					</ul>
				</div>
				<Button as="a" href="/login">
					Anmelden
				</Button>
			</main>
		</PublicLayout>
	);
}
